import { FlightEventHandler } from './flight'
import { writable } from 'svelte/store'
import { tick } from 'svelte'

const RADAR_MAX_SEEN_TIME = 5 * 1000 // 5s in millis

export default class RadarHits extends FlightEventHandler {
	constructor(flight) {
		super(flight)

		const { subscribe, set, update } = writable({});
		this.subscribe = subscribe
		this.set = set
		this.update = update
	}

	async handleKeyframe(keyframe) {
		this.set({})
		await tick()
		this.set(keyframe.radarTracks)
	}

	handleFlightStep(message) {
		if (!message.type.startsWith('RADAR_TRACK')) return
		this.update(allHits => {
			let hits = allHits[message.trackNumber]
			if (!hits) {
				hits = []
				allHits[message.trackNumber] = hits
			}
			hits.push(message)

			// Check timeouts
			for (const [key, hits] of Object.entries(allHits)) {
				if (!hits || hits.length <= 0) continue
				if (hits[hits.length - 1].timestamp < message.timestamp - RADAR_MAX_SEEN_TIME) {
					delete allHits[key]
				}
			}

			return allHits
		})
	}
}
